<template>
  <div>
    Insights
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>